import script from "./Registered.vue?vue&type=script&setup=true&lang=js"
export * from "./Registered.vue?vue&type=script&setup=true&lang=js"

import "./Registered.vue?vue&type=style&index=0&id=59786bf6&lang=css"

const __exports__ = script;

export default __exports__